import { Box, Typography } from '@mui/material'
import React from 'react'

export default function Updates() {
    return (
        <Box>
            <Typography variant='h4' color="white">Updates</Typography>
        </Box>
    )
}
